// extracted by mini-css-extract-plugin
export default {"orderArea":"Groups_orderArea__dX93J","orderTop":"Groups_orderTop__arnsn"};